export interface PriceSplitItem {
  productId: number;
  amount: number;
  itemName: string;
  enabled: boolean;
}

export const priceSplitConfig: PriceSplitItem[] = [
  { productId: 13, amount: 10, itemName: 'Kraujo paėmimas', enabled: true },
];

export const getPriceSplit = (productId: number): PriceSplitItem | null => {
  const item = priceSplitConfig.find((i) => i.productId === productId && i.enabled);

  return item || null;
};
